import { render } from "./TableFieldShow.html?vue&type=template&id=3a3b6110"
import script from "./TableFieldShow.ts?vue&type=script&lang=ts"
export * from "./TableFieldShow.ts?vue&type=script&lang=ts"

import "./TableFieldShow.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script